import { useFilteredIssueCount } from '@atlassian/jira-polaris-common/src/controllers/issue/selectors/filters-hooks.tsx';

export const useBoardIdeaCount = () => {
	const count = useFilteredIssueCount();

	return count;
};
